import HelloWorld from './HelloWorld'
import Particles from './Particles'
import ProfilePicture from './my-left-component/ProfilePicture'
import MainComponent from './my-left-component/MainComponent'
import AboutMe from './my-left-component/AboutMe'
import SkillsAndAbilities from './my-left-component/SkillsAndAbilities'
import SurfaceShader from './SurfaceShader'
import ProfessionalProject from './my-right-component/ProfessionalProject'
import SelfProject from './my-right-component/SelfProject'
import Mentors from './my-right-component/Mentors'
import RocketCard from './my-right-component/RocketCard'

export default {
  AboutMe,
  HelloWorld,
  ProfilePicture,
  Particles,
  MainComponent,
  SkillsAndAbilities,
  SurfaceShader,
  ProfessionalProject,
  SelfProject,
  Mentors,
  RocketCard
}



// WEBPACK FOOTER //
// ./src/components/index.js